import React from 'react'
import { ChipStyle } from './styled'

export const Chip = ({ color, titleColor, children, style, fontSize, ...props }) => {
  return <ChipStyle color={color} titleColor={titleColor} style={{ ...style }} {...props} fontSize={fontSize}>{children}</ChipStyle>
}

